import { useRef, useCallback } from "react";

export const useEventBus = () => {
  const listenersRef = useRef({});

  const emit = useCallback((event, data) => {
    if (listenersRef.current[event]) {
      listenersRef.current[event].forEach((cb) => cb(data));
    }
  }, []);

  const subscribe = useCallback((event, callback) => {
    if (!listenersRef.current[event]) {
      listenersRef.current[event] = [];
    }
    listenersRef.current[event].push(callback);

    return () => {
      listenersRef.current[event] = listenersRef.current[event].filter(
        (cb) => cb !== callback,
      );
    };
  }, []);

  return { emit, subscribe };
};
